import { useOrganizationsServiceOrganizationsAccessRetrieve } from '@organization/api/queries'
import { TeamShort } from '@organization/api/requests'
import { TitleActionButton } from '@organization/components'
import { paths } from '@organization/router'
import { LoadingScreen, Text } from '@shared/components'
import { Empty, Flex, Table } from 'antd'
import { Profile2User } from 'iconsax-react'

import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'

import { UserProfile } from '../components'

import type { ColumnsType } from 'antd/es/table'

export const UserDetails = () => {
  const { t } = useTranslation()
  const params = useParams()

  const { data, isLoading } =
    useOrganizationsServiceOrganizationsAccessRetrieve({
      id: Number(params.userId)
    })

  const column: ColumnsType<TeamShort> = [
    {
      key: 'team',
      title: t('common.team'),
      render: (_, { name, id }) => (
        <Link to={paths.teams.details(String(id))}>
          <Flex align="center" gap={8}>
            <Profile2User size="16" />
            <Text>{name}</Text>
          </Flex>
        </Link>
      )
    }
  ]

  if (isLoading) {
    return <LoadingScreen />
  }

  if (!isLoading && !data) {
    return <Empty />
  }

  return (
    <Flex vertical gap={20}>
      <UserProfile data={data} />

      <Table
        rowKey="id"
        pagination={false}
        dataSource={data?.teams ?? []}
        columns={column}
        title={(items) => (
          <TitleActionButton title={`${t('common.teams')} (${items.length})`} />
        )}
      />
    </Flex>
  )
}
